import React, { Component } from 'react';
import styled from '@emotion/styled';
import { Link } from 'gatsby';
import Layout from '../../components/layout';
import SEO from '../../components/seo';
import { motion } from 'framer-motion';
import LazyImage from '../../components/lazy-image';
import Label from '../../components/Label';
import ButtonUnderlined from '../../components/ButtonUnderlined';
import withUrlParams from '../../utils/withUrlParams';
import PropTypes from 'prop-types';
import HeaderThree from '../../blocks/headerThree';
import HeaderInsights from '../../blocks/headerInsights';
import Anchor from '../../blocks/anchor';
import FooterPreface from '../../blocks/footerPreface';
import Search from 'react-search';
import JsSearch from 'js-search';

import FeaturedPost from '../../components/Insights/featuredPost';
import StandardPost from '../../components/Insights/standardPost';
import TitleUnderlined from '../../components/TitleUnderlined';
import PostContainer from '../../components/Insights/postContainer';

import { Index } from 'elasticlunr';

const BlogOuterContainer = styled.div`
  min-height: calc(50vh - 120px - 310px);
  overflow: hidden;
`;

const BlogItemsOuterContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const BlogItemsContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 910px;
  flex-wrap: wrap;
  justify-content: space-between;
`;

const BlogOuterPostContainer = styled.div``;

const BlogCategoryItem = styled.div``;

const BlogItemContainer = styled.div`
  height: 480px;
  width: 420px;
  margin-left: 17.5px;
  margin-right: 17.5px;
  margin-bottom: 70px;
`;

const BlogCategorySelectorOuter = styled.div`
  width: 100%;
  height: 60px;
  margin-bottom: 100px;
  box-shadow: 0px 4px 6px rgba(136, 136, 136, 0.1);
`;

const BlogCategorySelector = styled.div`
  width: 100%;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 100px;
  @media (max-width: 740px) {
    width: 100vw;
    margin-bottom: 0px;
  }
  @media (max-width: 550px) {
    padding-left: 0px;
    padding-right: 0px;
    margin-bottom: 60px;
  }
`;

const ActiveCategoryItem = styled.div`
  font-family: 'DM Sans', sans-serif;
  -webkit-text-stroke-width: 0.5px;
  -webkit-text-stroke-color: black;
  font-weight: 600;
  font-size: 20px;
  display: flex;
  align-items: center;
  text-align: center;
  color: #404040;
  margin-left: 37.5px;
  margin-right: 37.5px;
  height: 100%;
  border-style: solid;
  border-width: 0px;
  border-bottom-width: 4px;
  border-color: #4758eb;
  cursor: pointer;
  margin-bottom: -4px;
  white-space: nowrap;
  @media (max-width: 740px) {
    margin-left: 15px;
    margin-right: 15px;
  }
  @media (max-width: 550px) {
    font-size: 14px;
    margin-left: 7.5px;
    margin-right: 7.5px;
  }
  @media (max-width: 350px) {
    font-size: 12px;
  }
`;

const InactiveCategory = styled.div`
  font-family: 'DM Sans', sans-serif;
  font-size: 20px;
  font-weight: 600;
  display: flex;
  align-items: center;
  text-align: center;
  color: #404040;
  margin-left: 37.5px;
  margin-right: 37.5px;
  height: 100%;
  border-style: solid;
  border-width: 0px;
  border-bottom-width: 4px;
  border-color: #fff;
  cursor: pointer;
  margin-bottom: -4px;
  opacity: 0.7;
  white-space: nowrap;
  @media (max-width: 740px) {
    margin-left: 15px;
    margin-right: 15px;
  }
  @media (max-width: 550px) {
    font-size: 14px;
    margin-left: 7.5px;
    margin-right: 7.5px;
  }
  @media (max-width: 350px) {
    font-size: 12px;
  }
`;

const EmptyChildrenStatement = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  font-weight: bold;
  font-size: 22px;
  margin-top: 50px;
  margin-bottom: 50px;
  @media (max-width: 740px) {
    display: none;
  }
`;

const LabelContainer = styled.div`
  width: 100%;
  margin-top: 35px;
  margin-left: 35px;
  margin-bottom: 15px;
`;

const PostTitle = styled.div`
  font-family: 'DM Serif Text', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 48px;
  display: flex;
  align-items: center;
  color: #404040;
  margin-left: 35px;
  width: calc(100% - 35px);
`;

const PostDescription = styled.div`
  font-family: 'DM Sans', sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 22px;
  letter-spacing: 0.01em;
  color: #404040;
  margin-left: 35px;
  width: calc(100% - 35px);
`;

const ButtonContainer = styled.div`
  margin-left: 35px;
  width: calc(100% - 35px);
  margin-top: 35px;
`;

const TitleContainer = styled.div`
  margin-bottom: 60px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  @media (max-width: 740px) {
    margin-top: 60px;
  }
  @media (max-width: 550px) {
    margin: 0;
    margin-bottom: 40px;
  }
`;

const POST_CATEGORIES = [
  'Ecommerce',
  'Downloadable Resources',
  'Industry Specific',
];
const POST_CATEGORIES_LINKS = [
  '/insights/ecommerce',
  '/insights/downloadable-resources',
  '/insights/industry-specific',
];
const POST_NUMBER = [1, 2, 3, 4];

export class Blog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeCategory: 'Ecommerce',
      categoryEmpty: false,
      evenNumber: false,
      loading: true,
      categoryNumber: 0,
      blogData: [],
    };
  }

  componentDidMount = () => {
    this.handleCategoryChange(this.state.activeCategory);
    /*
    let blogDataVar = [];
    this.props.data.allPrismicBlog.nodes.map((item, index) => {
      //console.log(item);
      let postTitleItems = [];
      let postTitle = item.data.blog_title.text;
      //console.log(item.data);
      let postData = {
        id: item.data.blog_title.text,
        value: item.data.blog_title.text,
      };
      //console.log(postData);
      blogDataVar.push(postData);
      if (index === this.props.data.allPrismicBlog.nodes.length - 1) {
        this.setState({
          blogData: blogDataVar,
        });
      }
      
      let postTitleWords = postTitle.split(' ');
      let wordArr = [];
      postTitleWords.map((word, index) => {
        if (word !== ' ' || word !== '' || word !== null) {
          //console.log(word);
          wordArr.push(word);
        }
        if (index === postTitleWords.length - 1) {
          let compArr = {
            data: item,
            words: wordArr,
          };
          blogData.push(compArr);
          //console.log(compArr);
        }
      });
      if (index === this.props.data.allPrismicBlog.nodes.length - 1) {
        //console.log('Blogdata', blogData);
      }
    });
    */
  };

  handleCategoryChange = category => {
    this.setState(
      {
        loading: false,
      },
      () => {
        if (this.state.activeCategory === 'all') {
          let categoryNum = '1';
          this.setState({
            categoryNumber: categoryNum,
          });
        }
        if (document.getElementById('BlogItemsContainer').hasChildNodes()) {
          this.setState(
            {
              categoryEmpty: false,
              loading: false,
            },
            () => {}
          );
        } else {
          this.setState({
            categoryEmpty: true,
            evenNumber: true,
            loading: false,
          });
        }
        if (
          document.getElementById('BlogItemsContainer').childElementCount === 0
        ) {
          alert('null');
        }
      }
    );
    let categoryNum = this.state.categoryNumber + 1;
    this.setState({ activeCategory: category, categoryNumber: categoryNum });
    setTimeout(function() {}.bind(this), 10);
  };

  CustomQueryStringComponent = ({ search }) => {
    const { custom } = search;
    return <p>Custom Value: {custom}</p>;
  };

  render() {
    let color = this.props.data.allPrismicInsightsRootPage.nodes[0].data
      .color_theme;
    return (
      <Layout
        menu_background={
          this.props.data.allPrismicInsightsRootPage.nodes[0].data
            .menu_background
        }
        logo={this.props.data.allPrismicInsightsRootPage.nodes[0].data.logo}
        header_items_color={
          this.props.data.allPrismicInsightsRootPage.nodes[0].data
            .header_items_color
        }
        mobile_logo={
          this.props.data.allPrismicInsightsRootPage.nodes[0].data.mobile_logo
        }
        mobile_header_items_color={
          this.props.data.allPrismicInsightsRootPage.nodes[0].data
            .mobile_header_items_color
        }
        fixed_background_transparent_mode={
          this.props.data.allPrismicInsightsRootPage.nodes[0].data
            .fixed_backgroud_transparent_mode
        }
        fixed_background_color={
          this.props.data.allPrismicInsightsRootPage.nodes[0].data
            .fixed_background_color
        }
        fixed_menu_items_color={
          this.props.data.allPrismicInsightsRootPage.nodes[0].data
            .fixed_menu_items_color
        }
        fixed_menu_logo={
          this.props.data.allPrismicInsightsRootPage.nodes[0].data.fixed_logo
        }
        fixed_mobile_logo={
          this.props.data.allPrismicInsightsRootPage.nodes[0].data
            .fixed_mobile_logo
        }
        header_background_color={
          this.props.data.allPrismicInsightsRootPage.nodes[0].data
            .header_background_color
        }
        display_review_bar={
          this.props.data.allPrismicInsightsRootPage.nodes[0].data
            .display_review_bar
        }
        footer_logo={
          this.props.data.allPrismicInsightsRootPage.nodes[0].data.footer_logo
        }
      >
        <SEO title="Insights" />
        <HeaderInsights
          header_text={
            this.props.data.allPrismicInsightsRootPage.nodes[0].data.title_text
          }
          subtitle_text={
            this.props.data.allPrismicInsightsRootPage.nodes[0].data
              .subtitle_text
          }
          color_theme={
            this.props.data.allPrismicInsightsRootPage.nodes[0].data.color_theme
          }
          background_color={
            this.props.data.allPrismicInsightsRootPage.nodes[0].data
              .splash_header_background_color
          }
          header_text_color={
            this.props.data.allPrismicInsightsRootPage.nodes[0].data
              .title_text_color
          }
          subtitle_text_color={
            this.props.data.allPrismicInsightsRootPage.nodes[0].data
              .subtitle_text_color
          }
          left_image={
            this.props.data.allPrismicInsightsRootPage.nodes[0].data
              .header_left_image
          }
          left_video={
            this.props.data.allPrismicInsightsRootPage.nodes[0].data
              .header_left_video
          }
          cta_text={
            this.props.data.allPrismicInsightsRootPage.nodes[0].data.cta_text
          }
          cta_link={
            this.props.data.allPrismicInsightsRootPage.nodes[0].data.cta_link
          }
          cta_text_color={
            this.props.data.allPrismicInsightsRootPage.nodes[0].data
              .title_text_color
          }
          nonLazyMode={false}
        />
        <Anchor anchor_id={'content'} />

        <BlogOuterContainer>
          <BlogCategorySelectorOuter>
            <BlogCategorySelector>
              <BlogCategoryItem>
                {'all' === this.state.activeCategory ? (
                  <ActiveCategoryItem>All</ActiveCategoryItem>
                ) : (
                  <Link to="/insights/">
                    <InactiveCategory>All</InactiveCategory>
                  </Link>
                )}
              </BlogCategoryItem>
              {POST_CATEGORIES.map((category, index) => (
                <BlogCategoryItem>
                  {category === this.state.activeCategory ? (
                    <ActiveCategoryItem>{category}</ActiveCategoryItem>
                  ) : (
                    <Link to={`${POST_CATEGORIES_LINKS[index]}/`}>
                      <InactiveCategory>{category}</InactiveCategory>
                    </Link>
                  )}
                </BlogCategoryItem>
              ))}
            </BlogCategorySelector>
          </BlogCategorySelectorOuter>
          <BlogItemsOuterContainer>
            <BlogItemsContainer id={'BlogItemsContainer'}>
              {this.state.loading ? null : (
                <React.Fragment>
                  <TitleContainer>
                    <TitleUnderlined
                      titleText={'<span>Latest</span>'}
                      fontSize={'40px'}
                      underlineColor={
                        this.props.data.allPrismicInsightsRootPage.nodes[0].data
                          .color_theme
                      }
                    />
                  </TitleContainer>
                  <PostContainer
                    data={this.props.data.allPrismicBlog.nodes}
                    activeCategory={this.state.activeCategory}
                    key={this.state.categoryNumber}
                    color={color}
                  />
                </React.Fragment>
              )}
            </BlogItemsContainer>
          </BlogItemsOuterContainer>
          <EmptyChildrenStatement>
            {this.state.categoryEmpty
              ? 'No posts could be found for this category.'
              : null}
          </EmptyChildrenStatement>
        </BlogOuterContainer>
        <FooterPreface
          subtitle_text={
            this.props.data.allPrismicInsightsRootPage.nodes[0].data
              .footer_preface_subtitle_text.text
          }
          main_text={
            this.props.data.allPrismicInsightsRootPage.nodes[0].data
              .footer_preface_title_text.text
          }
          cta_text={
            this.props.data.allPrismicInsightsRootPage.nodes[0].data
              .footer_preface_cta_text.text
          }
          cta_link={
            this.props.data.allPrismicInsightsRootPage.nodes[0].data.cta_link
              .url
          }
          cta_color={
            this.props.data.allPrismicInsightsRootPage.nodes[0].data.cta_color
          }
          footer_text_background_wave={
            this.props.data.allPrismicInsightsRootPage.nodes[0].data
              .squiggle_image.url
          }
          left_aligned_image={
            this.props.data.allPrismicInsightsRootPage.nodes[0].data
              .footer_preface_left_image
          }
          right_aligned_image={
            this.props.data.allPrismicInsightsRootPage.nodes[0].data
              .footer_preface_right_image
          }
        />
      </Layout>
    );
  }
}

export default withUrlParams(Blog);

export const query = graphql`
  query {
    allPrismicBlog {
      nodes {
        id
        tags
        url
        data {
          post_date
          blog_title {
            text
          }
          seo_description {
            text
          }
          post_excerpt {
            text
          }
          post_category
          featured_image {
            alt
            url
            localFile {
              id
              childImageSharp {
                fluid(maxWidth: 700) {
                  ...GatsbyImageSharpFluid_withWebp
                  presentationWidth
                }
              }
            }
          }
        }
      }
    }
    allPrismicInsightsRootPage {
      nodes {
        data {
          color_theme
          seo_title {
            text
          }
          seo_description {
            text
          }
          logo
          fixed_logo
          mobile_logo
          fixed_mobile_logo
          menu_logo
          display_review_bar
          splash_header_background_color
          header_background_color
          header_items_color
          menu_background
          mobile_header_items_color
          fixed_background_color
          fixed_menu_items_color
          fixed_background_transparent_mode
          footer_logo
          title_text {
            text
          }
          title_text_color
          subtitle_text {
            text
          }
          subtitle_text_color
          cta_text {
            text
          }
          cta_link {
            url
            slug
          }
          cta_color
          header_left_image {
            url
            alt
            localFile {
              id
              childImageSharp {
                fluid(maxWidth: 1920) {
                  ...GatsbyImageSharpFluid_withWebp
                  presentationWidth
                }
              }
            }
          }
          header_left_video {
            url
          }
          footer_preface_subtitle_text {
            text
          }
          footer_preface_title_text {
            text
          }
          footer_preface_cta_text {
            text
          }
          footer_preface_cta_link {
            url
            slug
          }
          footer_preface_left_image {
            url
            alt
            localFile {
              id
              childImageSharp {
                fluid(maxWidth: 1920) {
                  ...GatsbyImageSharpFluid_withWebp
                  presentationWidth
                }
              }
            }
          }
          footer_preface_right_image {
            url
            alt
            localFile {
              id
              childImageSharp {
                fluid(maxWidth: 1920) {
                  ...GatsbyImageSharpFluid_withWebp
                  presentationWidth
                }
              }
            }
          }
          squiggle_image {
            alt
            url
          }
        }
      }
    }
  }
`;

Blog.propTypes = {
  search: PropTypes.object,
};
